import { Component } from "@angular/core";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { AuthResponse, UserRoleAndPermissions } from "@apiserver-rest/ponder-auth-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { Subscription, take } from "rxjs";

@Component({
    selector: "delete-user-dialog",
    imports: [BusySpinComponent],
    templateUrl: "./delete-user-dialog.component.html"
})
export class DeleteUserDialogComponent {
    public isVisible: boolean = false;
    public user?: UserRoleAndPermissions;
    public isRunning: boolean = false;
    public deletionFailed: boolean = false;

    public readonly closeSvgIcon: string = SvgIconMap.get(SvgIcon.Close)!;

    private deleteUserSub!: Subscription;

    public constructor(private ponderAuthclient: PonderAuthClient, private events: EventBroker) {
        this.deleteUserSub = this.events.admin.deleteUserEvent.subscribe({
            next: (user: UserRoleAndPermissions) => {
                this.onOpen(user);
            }
        });
    }

    public ngOnDestroy(): void {
        this.deleteUserSub.unsubscribe();
    }
    
    private onOpen(user: UserRoleAndPermissions) {
        this.user = user;
        this.isVisible = true;
    }

    public onClose(): void {
        this.user = undefined;
        this.isVisible = false;
        this.deletionFailed = false;
    }

    public onConfirm(): void {
        if (this.isRunning || !this.user) {
            return;
        }

        this.isRunning = true;
        this.deletionFailed = false;

        this.ponderAuthclient
            .accountDelete(this.user.user.username)
            .pipe(take(1))
            .subscribe({
                next: (response: AuthResponse) => {
                    if (response.success) {
                        this.onClose();
                    } else {
                        this.deletionFailed = true;
                    }
                },
                error: () => {
                    this.deletionFailed = true;
                }
            })
            .add(() => { this.isRunning = false; });
    }
}